<template>
  <div>
    <form id="paymentForm" :action="paypal.action" method="post">
      <!-- merchant -->
      <input type="hidden" name="business" :value="paypal.business">
      <!-- suscribe button -->
      <input type="hidden" name="cmd" value="_xclick">
      <!-- options -->
      <input type="hidden" name="item_name" :value="paypal.item_name">
      <input type="hidden" name="currency_code" :value="paypal.currency_code">
      <input type="hidden" name="amount" :value="paypal.amount">
      <!-- redirects -->
      <input type="hidden" name="cancel_return" :value="`${app_url}#/payment?cancelled=true`">
      <input type="hidden" name="return" :value="`${app_url}#/payment?success=true`">
      <input type="hidden" name="notify_url" :value="`${api_url}paypal-ipn/`">
      <!-- custom data -->
      <input type="hidden" name="custom" :value="paypal.custom">
      <input type="hidden" name="no_shipping" value="1"/>
      <input type="hidden" name="no_note" value="1"/>
      <!-- input button -->
      <mu-flat-button type="button" class="button paypalBtn" @click="submitPayment" label="Pay via PayPal" :disabled="paypal.hasSubmitted === true"/>
    </form>
  </div>
</template>

<script>
  ;
  import config from '../../../config';

  export default {
    name: 'paypal-form',
    data() {
      return {
        app_url: null,
        api_url: null,
        product_name: '',
      }
    },
    props: {
      paypal: {
        type: Object,
        required: true
      }
    },
    methods: {
      submitPayment() {
        let self = this;
        // crucial, check if user id is set
        // process payment if user id exists
        if (self.paypal.custom === "" || self.paypal.custom === null || self.paypal.custom === 0 || self.paypal.custom === undefined) {
          self.$toastr.error('Cannot process payment. Please try again later');
        } else {
          self.paypal.hasSubmitted = true;
          $('#paymentForm')[0].submit();
        }
      }
    },
    mounted() {
      let self = this;
      let siteURL = '';
      if(config.ApplicationContext === 'lowcarbprogram') {
        siteURL = 'https://www.lowcarbprogram.com/';
      } else {
        siteURL = 'https://www.grohealth.com/';
      }
      self.app_url = siteURL + config.locale + '/';
      self.api_url = config.apiUrl;
    }
  }

</script>



// WEBPACK FOOTER //
// index.vue?281562ce